import './ClubCardModal.css'

import { CloseButton, EmptyResults, Modal } from 'components'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import ClubCardModalTableHeader from './ClubCardModalTableHeader'
import ClubCardModalTableRow from './ClubCardModalTableRow'

function ClubCardModal({ countriesClubShare, isFetching, isOpen, onClose, onSort, sort }) {
  const { t: translate } = useTranslation()
  const maxBarValue = Math.max(...countriesClubShare.map(({ clubSharePercent }) => clubSharePercent))

  return (
    <Modal isOpen={isOpen} hideModal={onClose}>
      <div className="club-card-modal">
        <div className="header flex-row">
          <div className="title">{translate('clubCardModal.shareClubCard')}</div>

          <CloseButton onClick={onClose} />
        </div>

        {!isFetching && countriesClubShare.length > 0 && (
          <>
            <ClubCardModalTableHeader onSort={onSort} sort={sort} />

            {countriesClubShare.map(countriesClubShareProps => (
              <ClubCardModalTableRow key={countriesClubShareProps.channel} maxBarValue={maxBarValue} {...countriesClubShareProps} />
            ))}
          </>
        )}

        {!isFetching && countriesClubShare.length === 0 && <EmptyResults />}
      </div>
    </Modal>
  )
}

ClubCardModal.propTypes = {
  countriesClubShare: PropTypes.array,
  isFetching: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSort: PropTypes.func,
  sort: PropTypes.shape({
    sortBy: PropTypes.string,
  }),
}

export default ClubCardModal
